import axios from "axios";

// Administração do cluster (serviço jobs/, via Kong em /admin-api). A credencial é o login de uma
// conta de administrador (token do Firebase) ou o ADMIN_TOKEN de emergência. Ela vai só no
// cabeçalho Authorization: nunca na URL (ficaria nos logs).
const admin = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_LOCATION || "/admin-api",
  timeout: 15000
});

const auth = token => ({ headers: { Authorization: `Bearer ${token}` } });

export const fetchWhoami = token => admin.get("/whoami", auth(token));

export const fetchOverview = token => admin.get("/overview", auth(token));

export const fetchRun = (token, runId) => admin.get(`/runs/${encodeURIComponent(runId)}`, auth(token));

export const fetchRunLog = (token, runId, lines) =>
  admin.get(`/runs/${encodeURIComponent(runId)}/log`, { ...auth(token), params: { lines } });

// Apaga o registro de uma execução terminada, ou de todas (sem runId). Na fila ou rodando: 409
export const deleteRuns = (token, runId) =>
  admin.delete(runId ? `/runs/${encodeURIComponent(runId)}` : "/runs", auth(token));
